/* eslint-disable */
import {
  Box,
  Grid,
  InputAdornment,
  Stack,
  styled,
  TextField,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Checkbox,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SearchIcon from "@mui/icons-material/Search";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import MainLoader from "../MainLoader/MainLoader";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteWebsitePopup from "../Modal/components/DeleteWebsitePopup";
import { convertUTCDateToLocalDate } from "../../utils/myUtills";
import { usePopup } from "../../context/commonPop";

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& .inputWrapperAverage": {
    "& .MuiFormControl-root": {
      "& .MuiInputBase-root": {
        "& input": {
          color: theme.palette.text.primary,
          "& div": {
            color: theme.palette.text.primary,
          },
        },
      },
      "& label": {
        marginBottom: "0",
        top: "50%",
        transform: "translate(14px, -50%)",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "17.64px",
        textAlign: "left",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        "&.MuiInputLabel-shrink": {
          top: "0",
          transform: "translate(14px, -9px) scale(0.75)",
        },
      },
      "& .MuiAutocomplete-root": {
        "& .MuiInputBase-root": {
          paddingTop: "4.5px",
          paddingBottom: "4.5px",
        },
      },
      "& .MuiFormHelperText-root": {
        position: "absolute",
        top: "40px",
        left: "0",
      },
    },
  },
  "& .searchKeywordBox": {
    "& .addKeyword": {
      // textAlign: "start",
      // "& a": {
      //   width: "100%",
      // },
      "& button": {
        height: "100%",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        "@media screen and (max-width:600px)": {
          width: "100%",
        },
        // "& a": {
        //   color: theme.palette.common.textColor,
        //   width: "100%",
        //   "&:hover": { textDecoration: "none" },
        // },
        "&:hover": {
          backgroundColor: theme.palette.common.hoverBtn,
          color: theme.palette.common.white,
          "& a": {
            color: theme.palette.common.white,
          },
        },
      },
    },
  },
  "& .keywordResultTable": {
    width: "100%",
    "& .tableFooter": {
      padding: "20px 15px 20px 15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
      gap: "20px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
      },
      "& .filteredContent": {
        "@media screen and (max-width:600px)": {
          flexWrap: "wrap",
          justifyContent: "space-between",
        },
      },
      "& .paginationBox": {
        backgroundColor: "#2A35470D",
        padding: "3px 4px",
        minWidth: "200px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "5px",
        "& button": {
          padding: "0",
          backgroundColor: "transparent",
          "&:focus": {
            outline: "none",
          },
          "&:hover": {
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          },
        },
        "& .actionBtnBox": {
          color: "#757575",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "&:hover": {
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            "& svg": {
              fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            },
          },
          "& svg": {
            fill: "#757575",
          },
          "& span": {
            fill: "#757575",
          },
        },
        "& .pageValue": {
          borderLeft: "1px solid #757575",
          borderRight: "1px solid #757575",
          padding: "0 5px",
          "& p": {
            fontSize: "12px",
            fontWeight: 700,
            lineHeight: "15.12px",
            textAlign: "left",
            color: theme.palette.text.primary,
          },
        },
      },
      "& .enteredTop": {
        width: "6px",
        height: "6px",
        backgroundColor: "#0276E3",
        borderRadius: "50%",
      },
      "& .inTop": {
        width: "6px",
        height: "6px",
        backgroundColor: "#3DAE88",
        borderRadius: "50%",
      },
      "& .leftTop": {
        width: "6px",
        height: "6px",
        backgroundColor: "#FF6445",
        borderRadius: "50%",
      },
      "& .EnterTopHundred": {
        width: "6px",
        height: "6px",
        backgroundColor: "#7687A3",
        borderRadius: "50%",
      },
      "& .footerInnerContent": {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        "& p": {
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "15.12px",
          textAlign: "left",
          color: "#808080",
          "& span": {
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "15.12px",
            textAlign: "left",
            color: "#808080",
          },
        },
      },
    },
    "& .innerTableGrid": {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: "7px 7px 7px 7px",
      "& table thead": {
        backgroundColor: theme.palette.text.primary,
        "& tr th": {
          color: theme.palette.mode === "dark" ? "#2A3547" : "#fff",
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "15.12px",
          textAlign: "left",
          "&:first-of-type": {
            textAlign: "left",
            "@media screen and (max-width:600px)": {
              minWidth: "190px",
            },
          },
          "&:nth-of-type(2)": {
            textAlign: "left",
            "@media screen and (max-width:600px)": {
              minWidth: "190px",
            },
          },
          "&:nth-of-type(3)": {
            textAlign: "left",
            "@media screen and (max-width:600px)": {
              minWidth: "190px",
            },
          },
        },
      },
      "& table ": {
        border: "1px solid #E3E3E3",
      },
      "& table tbody": {
        height: "190px",
        overflow: "auto",
        "& tr": {
          "&:last-of-type": {
            borderBottom: "1px solid ",
          },
        },
        "& tr td": {
          color: theme.palette.text.primary,
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "15.12px",
          textAlign: "left",
          "& .serpFeature": {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            "& .starIcon": {
              color: theme.palette.primary.main,
            },
            "& .videoIcon": {
              color: "#7F7F7F",
            },
          },
          "& .dateBoxes": {
            backgroundColor: "#2A35470D",
            textAlign: "center",
            padding: "6px",
            borderRadius: "4px",
          },
          "& .contentScore": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: "20px",
            color: "#fff",
            "& .inpuField": {
              width: "46px",
              "& fieldset": {
                display: "none",
              },
              "& input": {
                padding: "3px 9px",
                textAlign: "center",
                color: "#fff",
              },
            },
          },
          "& .contentScoreWarning": {
            backgroundColor: "#FFFF00",
            borderRadius: "20px",
            color: "#ffffff",
            "& .inpuField": {
              width: "46px",
              "& fieldset": {
                display: "none",
              },
              "& input": {
                padding: "3px 9px",
                textAlign: "center",
                color: "#000",
              },
            },
          },
          "& .contentScoreDanger": {
            backgroundColor: "#ff0000",
            borderRadius: "20px",
            color: "#fff",
            "& .inpuField": {
              width: "46px",
              "& fieldset": {
                display: "none",
              },
              "& input": {
                padding: "3px 9px",
                textAlign: "center",
                color: "#fff",
              },
            },
          },
          "& .contentScoreDown": {
            "& svg": {
              fill: "red",
            },
            "& span": {
              color: "red",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "15.12px",
              textAlign: "left",
            },
          },
          "& .contentScoreInner": {
            color: theme.palette.primary.main,
            "& span": {
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "15.12px",
              textAlign: "left",
            },
          },
        },
      },
    },
  },
}));
function LegendAndPagination({ currentPage, totalPages, handleNext, handlePrevious, disablePrevious, disableNext }) {
  return (
    <Box className="tableFooter">
      <Stack direction="row" spacing={2} className="filteredContent">
        <Box className="footerInnerContent">
          <Typography component="span" className="enteredTop"></Typography>
          <Typography component="p">
            Entered Top <Typography component="span">10</Typography>{" "}
          </Typography>
        </Box>
        <Box className="footerInnerContent">
          <Typography component="span" className="inTop"></Typography>
          <Typography component="p">
            In Top <Typography component="span">10</Typography>
          </Typography>
        </Box>
        <Box className="footerInnerContent">
          <Typography component="span" className="leftTop"></Typography>
          <Typography component="p">
            Left Top <Typography component="span">10</Typography>
          </Typography>
        </Box>
        <Box className="footerInnerContent">
          <Typography component="span" className="EnterTopHundred"></Typography>
          <Typography component="p">
            Entered Top <Typography component="span">100</Typography>
          </Typography>
        </Box>
      </Stack>
      <Box className="paginationBox">
        <Button onClick={handlePrevious} disabled={disablePrevious}>
          <ArrowLeftIcon />
          <Typography component="span">Previous</Typography>
        </Button>
        <Box className="pageValue">
          <Typography component="p">
            Page {currentPage} of {totalPages}
          </Typography>
        </Box>
        <Button onClick={handleNext} disabled={disableNext}>
          <Typography component="span">Next</Typography>
          <ArrowRightIcon />
        </Button>
      </Box>
    </Box>
  );
}
function showArraow(changes, style, rank) {
  if (changes == rank) return "";
  if (changes > 0) {
    return <ArrowDropUpIcon sx={{ color: `${style} !important` }} />;
  }
  if (changes < 0) {
    return <ArrowDropDownIcon sx={{ color: `${style} !important` }} />;
  }
}

function KeywordFeatureTable({
  rankingData,
  dropDownValue,
  setDropDownValue,
  search,
  setSearch,
  handleCheckboxChange,
  setMaxActiveIcons,
  countActiveIcons,
  modelOpen,
  setModelOpen,
  handleDelete,
  queryObj,
  setQueryObj,
}) {
  const [scoreValue, setScoreValue] = useState(98);
  const [filteredRows, setFilteredRows] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { handleOpen } = usePopup();

  const rowsPerPage = 10;
  const rows = search && filteredRows?.length > 0 ? filteredRows : rankingData?.rows || [];

  const paginatedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const totalPages = Math.ceil(rows.length / rowsPerPage);

  const handleNext = () => {
    setCurrentPage(prev => (prev < totalPages ? prev + 1 : prev));
  };

  const handlePrevious = () => {
    setCurrentPage(prev => (prev > 1 ? prev - 1 : prev));
  };

  const debouncedHandleChange = useCallback(
    debounce(value => {
      setSearch(value);
    }, 300),
    [],
  );
  const handleChange = e => {
    if (e.target.name == "search") return debouncedHandleChange(e.target.value);
    return setDropDownValue(e.target.value);
  };

  const handlescoreValue = e => {
    setScoreValue(e.value.target);
  };
  const handleDownload = () => {
    if (!rankingData || !rankingData.rows || rankingData.rows.length === 0) {
      handleOpen(true, "No data available to download.");
      return;
    }
    try {
      let csvContent = rankingData?.columns.join(",") + "\n";

      rankingData.rows.forEach(row => {
        const csvRow = rankingData.columns.map(column => {
          switch (column) {
            case "POSITION":
              return row.rank;
            case "KEYWORDS":
              return row.keywords;
            case "CHANGE":
              return row.changes?.changes ?? "";
            case "VOL":
              return row.searchVolume ?? "";
            case "S.D.":
              return row.difficulty_score ?? "";
            case "URL":
              return row.url;
            case "UPDATED":
             return `"${convertUTCDateToLocalDate(row?.updatedAt)}"`;
            default:
              return "";
          }
        });
        csvContent += csvRow.join(",") + "\n";
      });
      const blob = new Blob([csvContent], { type: "text/csv" });

      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `ranking_details.csv`;
      a.style.display = "none";

      document.body.appendChild(a);
      a.click();

      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.log("error", error);
      handleOpen(true, "Something went wrong while downloading the CSV file.");
    }
  };

  useEffect(() => {
    let maxCount = 0;
    rows.forEach(row => {
      const activeIcons = countActiveIcons(row);
      if (activeIcons > maxCount) {
        maxCount = activeIcons;
      }
    });
    setMaxActiveIcons(maxCount);
  }, [rankingData, rows]);

  const handleOpenModel = (keyword, id) => {
    setQueryObj({ keyword, id });
    setModelOpen(true);
  };
  return !rankingData || !rankingData.rows ? (
    <MainLoader />
  ) : (
    <BoxWrapper>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: { xs: "block", sm: "flex" }, gap: "10px" }} className="searchKeywordBox">
            <Box sx={{ minWidth: { xs: "144px", sm: 193 }, mb: { xs: "15px", sm: "unset" } }} className="inputWrapperAverage">
              <TextField
                variant="outlined"
                placeholder="Search keyword"
                name="search"
                onChange={handleChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box className="addKeyword">
              <Button onClick={() => handleDownload()}>Export to csv</Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box className="keywordResultTable">
            <TableContainer className="innerTableGrid">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>SELECT</TableCell>
                    {rankingData?.columns.map(column => (
                      <TableCell key={column}>{column}</TableCell>
                    ))}
                    <TableCell>DELETE</TableCell>
                  </TableRow>
                </TableHead>
                {
                  <TableBody>
                    {paginatedRows.length > 0 ? (
                      paginatedRows.map((row, index) => {
                        const rowIndex = (currentPage - 1) * rowsPerPage + index;
                        const activeIconCount = countActiveIcons(row);
                        return (
                          <TableRow key={row.id}>
                            <TableCell>
                              <Checkbox checked={row.isChecked} onChange={e => handleCheckboxChange(e, rowIndex)} color="primary" />
                            </TableCell>
                            <TableCell sx={{ color: `${row?.fontColor} !important` }}>{row?.rank || 0}</TableCell>
                            <TableCell>{row?.keywords || ""}</TableCell>
                            <TableCell sx={{ color: `${row?.changes?.color} !important` }}>
                              {row?.changes?.changes || 0} {showArraow(row?.changes?.changes || 0, row?.changes?.color, row?.rank || 0)}
                            </TableCell>
                            <TableCell align="left">{row?.searchVolume || 0}</TableCell>
                            <TableCell>{row?.difficulty_score || 0}</TableCell>
                            <TableCell>{row?.url || ""}</TableCell>
                            <TableCell>{convertUTCDateToLocalDate(row?.updatedAt)}</TableCell>
                            <TableCell>
                              <Tooltip title="Delete this keyword" arrow onClick={() => handleOpenModel(row?.keywords, row?.id)}>
                                <DeleteIcon />
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} sx={{ padding: 0 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              minHeight: "200px",
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" color="textSecondary">
                              No Data Found
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                }
              </Table>
              <LegendAndPagination
                currentPage={currentPage}
                totalPages={totalPages}
                handleNext={handleNext}
                handlePrevious={handlePrevious}
                disableNext={currentPage >= totalPages || totalPages === 0}
                disablePrevious={currentPage === 1}
              />
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
      <DeleteWebsitePopup open={modelOpen} setOpen={setModelOpen} onSubmit={handleDelete} />
    </BoxWrapper>
  );
}

export default KeywordFeatureTable;
